import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';

class Cookies extends Component {
    render() {
        return (
            <div>
                <PageTitle title="Cookies" bgimgurl="/img/titlebg/contatti.jpg"></PageTitle>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p> COSA SONO?</p>
                            <p>
                                I cookies sono stringhe di testo di piccole dimensioni conservate nel tuo computer
                                quando si visitano determinate pagine su internet. Se non vuoi accettare i cookies,
                                potrai comunque navigare sul sito e usarlo per finalità di ricerca. Nella maggior
                                parte dei browser, i cookies sono abilitati.
                            </p>
                            <p>
                                A COSA SERVONO?
                            </p>
                            <p>
                                I cookies non sono dannosi per il tuo device. Nei cookies che generiamo, non conserviamo
                                informazioni identificative personali ma usiamo informazioni criptate raccolte dagli
                                stessi per migliorare la tua permanenza sul sito.
                            </p>
                            <p>
                                QUALI USA QUESTO SITO?
                            </p>
                            <p>
                                <b>Cookies tecnici (strettamente necessari)</b><br />
                                Questi cookie sono essenziali per consentirti di navigare nel sito e utilizzare
                                tutte le funzionalità. Senza questi cookie, che sono assolutamente necessari, non
                                saremmo in grado di fornirti alcuni servizi o funzioni e la navigazione sul sito
                                non sarebbe agevole e facile come dovrebbe essere.
                            </p>
                            <p>
                                <b>Cookies analitici</b><br />
                                Raccolgono informazioni su come un visitatore usa il sito, quali ad esempio le pagine
                                visitate. Questi cookies non raccolgono informazioni che possono identificare l’utente.
                                Tutte le informazioni raccolte da questi cookies sono aggregate in forma anonima
                                e sono utilizzate solo per migliorare la funzionalità del sito.
                            </p>
                            <p>
                                COME DISATTIVARLI
                            </p>
                            <p>
                                Questo sito funziona in modo ottimale se i cookies sono abilitati.<br />
                                Puoi decidere le modalità di utilizzo dei cookies sul tuo computer; per farlo accedi
                direttamente alle impostazioni del tuo browser.<br />
                                Per dettagli su come modificare tali impostazioni seleziona il browser che stai
                utilizzando:<br />
                                <a rel="noopener noreferrer" href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank">
                                    Firefox
                                </a><br />
                                <a rel="noopener noreferrer" href="http://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11" target="_blank">Internet Explorer</a><br />
                                <a rel="noopener noreferrer" href="https://support.google.com/chrome/answer/95647?hl=it" target="_blank">
                                    Google
                                    Chrome
                                </a><br />
                                <a rel="noopener noreferrer" href="https://support.apple.com/it-it/HT201265" target="_blank">Safari</a><br />
                                Ricordati che se disattivi i cookies, potresti disabilitare alcune funzionalità
                                del sito.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Cookies;


// WEBPACK FOOTER //
// ./src/pages/Cookies.js